$(document).on("click", ".bx-filter-parameters-box-title", function () {
  if (window.innerWidth < 1279) {
    const $wrapper = $(this).parent();
    const $block = $(this).next();
    console.log("###offset height", $block.outerHeight());

    $wrapper.toggleClass("bx-active");

    $block.slideToggle();
  }
});

$(window).on("load", function () {
  $(".catalog-filter .bx-filter-parameters-box-container").each((idx, item) => {
    const ps = new PerfectScrollbar(item, {
      wheelPropagation: false,
    });
  });
});

$("body").on("mousewheel", function (e) {
  e.preventDefault();
  const $target = $(e.target);

  if ($target.closest(".bx-filter-parameters-box-container").length) {
    e.preventDefault();
  }
});

$(".catalog-filter .bx-filter-parameters-box-container");

const isAnyCheckboxChecked = () => {
  if ($('.catalog-filter input[type="checkbox"]:checked').length) {
    $(".catalog-filter__clear").removeAttr("disabled");
    $(".clear-filter-wrp.visible-xl input").removeAttr("disabled");
  } else {
    $(".catalog-filter__clear").attr("disabled", true);
    $(".clear-filter-wrp.visible-xl input").attr("disabled", true);
  }
};

isAnyCheckboxChecked();

$(document).on("change", '.catalog-filter input[type="checkbox"]', function () {
  isAnyCheckboxChecked();
});

// function addCatalogFilterVariables() {
//   const $catalog = $(".catalog-filter");

//   if ($catalog.length) {
//     $catalog.css({
//       "--w": `${$catalog.outerWidth()}px`,
//       "--ol": `${$catalog.offset().left}px`,
//     });
//   }
// }

// $(window).on("scroll", function () {
//   const $wrapper = $(".catalog-filter__clear-inner");
//   const $catalog = $(".catalog-filter");
//   if ($wrapper.length && $catalog.length) {
//     if ($catalog.offset().top + $catalog.outerHeight() - $(window).scrollTop() - $(window).height() > 78) {
//       $wrapper.addClass("is--fixed");
//     } else {
//       $wrapper.removeClass("is--fixed");
//     }
//   }
// });

// addCatalogFilterVariables();

// $(window).on("resize", function () {
//   addCatalogFilterVariables();
// });

if ($(".catalog-filter").length) $(".wrapper").css("overflow", "unset");
if ($(".catalog-list__promo-benefits .catalog-list__promo-benefit").length < 4) {
  $(".catalog-list__promo-benefits").addClass("is--short");
}
